import React, { useState, useEffect } from 'react';

import { useLocation  } from 'react-router-dom';

import NavBarItems from './NavBarItems';
import BakashalInfo from './BakashalInfo';
// import ProcessInfo from './ProcessInfo';
import ProcessInfoContainer from './ProcessInfoContainer';
import VahadaInfo from './VahadaInfo';
import LocationInfo from './LocationInfo';
import AreasInfo from './AreasInfo';
// import TnaimInfo from './TnaimInfo';
import ArchivInfo from './ArchivInfo';
import PageBar from '../../CustomeComponents/PageBar';
import TnaimInfoContainer from './TnaimInfoContainer';

const NavBarContainer = (props) => {
    const [componentName, setComponentName] = useState("");
    const [compDate, setCompDate] = useState("");
    const [compTitle, setCompTitle] = useState("");
    const [compTik, setCompTik] = useState("");
    const [isMobile, setIsMobile] = useState(false);
    const { search } = useLocation();

    useEffect(() => {
        const compName = new URLSearchParams(search).get("Page");
        const compTikNum = new URLSearchParams(search).get("TikNum");
        let title = ""
        if(compName === "BakashalInfo") {
            title = "תיאור הבקשה";
        } else if(compName === "ProcessInfo") {
            title = "תהליך בתיק";
        } else if(compName === "VahadaInfo") {
            title = "החלטות הוועדה";
        } else if (compName === "LocationInfo") {
            title = "נתוני מיקום";
        } else if (compName === "AreasInfo") {
            title = "שטחים";
        } else if (compName === "TnaimInfo") {
            title = "תנאים לקידום תיק";
        } else { //ArchivInfo
            title = "ארכיב אופטי";
        }

        const date = new Date();
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        setComponentName(compName);
        setCompTik(compTikNum);
        setCompTitle(title);
        setCompDate(`${day}/${month}/${year}`);
        setIsMobile(window.innerWidth < 768);
    }, []);

    useEffect(() => {
        if(props.pageEvent === 'Header') {
            window.location.reload();
        }
    }, [props]);

    const renderComponent = (compName) => {
        let componentToRender;

        switch (compName) {
            case "BakashalInfo":
                componentToRender = <BakashalInfo isSeparate={false} />;
                break;
            case "ProcessInfo":
                // componentToRender = <ProcessInfo />;
                componentToRender = <ProcessInfoContainer isSeparate={false}/>;
                break;
            case "VahadaInfo":
                componentToRender = <VahadaInfo isSeparate={false} />;
                break;
            case "LocationInfo": 
                componentToRender = <LocationInfo isSeparate={false} />; 
                break;
            case "AreasInfo": 
                componentToRender = <AreasInfo isSeparate={false} />; 
                break;
            case "TnaimInfo": 
                // componentToRender = <TnaimInfo />;
                componentToRender = <TnaimInfoContainer isSeparate={false} />;
                break;
            case "ArchivInfo": 
                componentToRender = <ArchivInfo isSeparate={false} />; 
                break;
            default:
                componentToRender = <div>אדם חכם אמר פעם: "לעולם אל תסמוך על דף שאינך יכול למצוא"</div>
                break;
        }
        return componentToRender;
    }

    const changeComponent = (name) => {
        setComponentName(name);
    }

    const TitleProcessComp = () => {
        return (
            <div id="tikToPrint" style={{ margin: "-10px 15px" }} > {/* style={{ visibility: 'hidden', width: "1200px" }} */}
                <PageBar className="container my-3" >
                    <div className="d-flex gap-4" style={{ margin: "10px 0px", fontSize: "larger"}}>
                        <span style={{ zIndex: -1 }}> {/* style={{ zIndex: -10 }} */}
                            <span><b>תיק: </b></span>
                            <span>{`${compTik}`}</span>
                        </span>
                        <span style={{ zIndex: -1 }}>
                            {/* <span><b>כותרת: </b></span> */}
                            <span>,{compTitle},</span>
                        </span>
                        <span style={{ zIndex: -1 }}>
                            <span><b>תאריך: </b></span>
                            <span>{compDate}</span>
                        </span>
                    </div>
                </PageBar>
            </div>
        )
    }

    return (
        <>
            <NavBarItems componentName={componentName} changeComponent={changeComponent}/>
            <div className="container my-3 my-lg-5" >
                <TitleProcessComp />
                <div className="nav-bar-container" >
                    {renderComponent(componentName)}
                </div>
            </div>
        </>
    )
}

export default NavBarContainer